/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationInsertCuepointCuepointsMutationRequest, YoutubeIntegrationInsertCuepointCuepointsMutationResponse, YoutubeIntegrationInsertCuepointCuepointsPathParams, YoutubeIntegrationInsertCuepointCuepoints401, YoutubeIntegrationInsertCuepointCuepoints403 } from "../models/YoutubeIntegrationInsertCuepointCuepoints";

export function getYoutubeIntegrationInsertCuepointCuepointsUrl(station: YoutubeIntegrationInsertCuepointCuepointsPathParams["station"]) {
  const res = { method: 'POST', url: `/youtube-integration/v1/cuepoints/${station}` as const }
  return res
}

/**
 * @description Resolves channel and live video from station settings (with legacy youtubeChannelId fallback), optional body `liveVideoId`, and active live registry. `cueType` is always `cueTypeAd`.
 * @summary Insert an ad cuepoint for the station live broadcast
 * {@link /youtube-integration/v1/cuepoints/:station}
 */
export async function youtubeIntegrationInsertCuepointCuepoints(station: YoutubeIntegrationInsertCuepointCuepointsPathParams["station"], data: YoutubeIntegrationInsertCuepointCuepointsMutationRequest, config: Partial<RequestConfig<YoutubeIntegrationInsertCuepointCuepointsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<YoutubeIntegrationInsertCuepointCuepointsMutationResponse, ResponseErrorConfig<YoutubeIntegrationInsertCuepointCuepoints401 | YoutubeIntegrationInsertCuepointCuepoints403>, YoutubeIntegrationInsertCuepointCuepointsMutationRequest>({ method : "POST", url : getYoutubeIntegrationInsertCuepointCuepointsUrl(station).url.toString(), data : requestData, ... requestConfig })
  return res.data
}